import React, { useEffect } from "react";
import FlipCardSlider from "../../components/Slider/FlipCardSlider";
import ArticleContainer from "../../components/Article/ArticleContainer";
import ArticleHero from "../../components/Hero/ArticleHero";

const relatedBlogs = [
  {
    contentType: "BLOG",
    title: "Complimenting Fleet Modernization with Road Safety",
    description:
      "Shoora is leading the charge in transforming fleet operations by enhancing safety and operational efficiency through the Voluntary Vehicle-Fleet Modernization Programme (VVMP).",
    link: "/insights/blog/complimenting-fleet-modernization-with-road-safety",
    linkText: "Read article",
    thumbnail:
      "https://images.pexels.com/photos/11389692/pexels-photo-11389692.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Envisioning the Future of Mobility with Shoora",
    description:
      "Shoora offers comprehensive fleet management solutions that track vehicle locations, monitor driver performance, optimise routes, and reduce fuel consumption.",
    thumbnail: "/images/thumbnails/14.jpeg",
    link: "/insights/blog/envisioning-the-future-of-mobility-with-shoora",
    readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Leverage AIS-140’s Mandate for Telematics Devices",
    description:
      "Shoora, a leader in advanced video telematics solutions , is committed to harnessing the potential of this mandate to create safer roads and smarter transportation systems.",
    thumbnail: "https://www.easyembedded.net/images/ais2.jpg",
    link: "/insights/blog/how-shoora-aims-to-leverage-ais-140s-mandate-for-telematics-devices-in-public-transportation-and-commercial-vehicles",
    readTime: 10,
  },

  {
    contentType: "BLOG",
    title: "Truck Driver Safety Tips: A Guide to Protecting Lives on the Road",
    description:
      "Shoora, through its advanced video telematics solutions, is helping to curb these numbers and protect lives.",
    thumbnail:
      "https://images.pexels.com/photos/27946843/pexels-photo-27946843/free-photo-of-truck-rearview-mirror.jpeg?auto=compress&cs=tinysrgb&w=600",
    link: "/insights/blog/truck-driver-safety-tips-a-guide-to-protecting-lives-on-the-road",
    readTime: 10,
  },
  {
    contentType: "CUSTOMER STORY",
    title: "Shoora Life Savers Helped BLR Logistics Avert Over 7,500 Accidents",
    description:
      "Shoora is not just a service provider for BLR Logistics; they are a trusted safety partner.",
    thumbnail:
      "https://images.jdmagicbox.com/v2/comp/mumbai/26/022p1955726/catalogue/blr-logistics-india-ltd-goregaon-east-mumbai-transporters-for-all-india-3m98o5wutw.jpg",
    link: "/insights/customer-stories/how-shoora-life-savers-helped-blr-logistics-avert-over-7500-accidents",
    readTime: 10,
  },

  {
    contentType: "CUSTOMER STORY",
    title: "Kapoor Diesels Truck Achieves 1,60,200 Accident-Free Kilometres",
    description:
      "The integrated suite of technologies offered Kapoor Diesel enhanced safety, better fleet management, and measurable cost savings.",
    thumbnail: "/images/thumbnails/15.jpeg",
    link: "/insights/customer-stories/kapoor-diesel-fleet-achieves-60200-accident-free-kilometres-with-shooras-cutting-edge-video-telematics-solutions",
    readTime: 10,
  },
];
const data = {
  contentType: "Article",
  title: "RoadSense™ ADAS Cameras – Redefining Fleet Safety and Performance",
  description:
    "RoadSense™ by Shoora is your ultimate solution for safer fleet operations. Equipped with advanced AI technology, this road-facing dash cam actively monitors and alerts drivers to potential risks, ensuring accidents are prevented before they happen.",
  author: "Shoora",
  createdOn: "2nd Nov, 2024",
  imgsrc: "/images/thumbnails/3.jpeg",
  readTime: 10,
  content: ` 
     <h2>
        AI-Driven Risk Detection. Instant Video Evidence. Expert Coaching
        On-the-Go.
      </h2>
      <p>
        RoadSense™ by Shoora is your ultimate solution for safer fleet
        operations. Equipped with advanced AI technology, this road-facing dash
        cam actively monitors and alerts drivers to potential risks, ensuring
        accidents are prevented before they happen.
      </p>

      <h2>Revolutionizing Road Safety with Advanced ADAS Technology</h2>
      <h4>1. Proactive Collision Avoidance</h4>
      <p>
        RoadSense™ detects and addresses risks in real time to keep your fleet
        safe:
      </p>
      <ul>
        <li>
          <strong>Lane Departure Warning (LDW):</strong> Notifies drivers when
          they drift out of their lane.
        </li>
        <li>
          <strong>Forward Collision Warning (FCW):</strong> Warns of potential
          collisions to allow quick corrective action.
        </li>
        <li>
          <strong>Pedestrian Detection (PD):</strong> Identifies pedestrians and
          alerts drivers, preventing incidents.
        </li>
        <li>
          <strong>Proximity Alert:</strong> Coaches drivers to maintain safe
          following distances.
        </li>
        <li>
          <strong>Frontal Collision Alert:</strong> Alerts drivers to imminent
          forward collisions for timely response.
        </li>
      </ul>
      <p>
        With these intelligent features, RoadSense™ ensures your fleet operates
        with precision and safety, reducing risks and protecting lives.
      </p>

      <h4>2. Instant Access to Critical Video Evidence</h4>
      <p>
        Take control of post-incident scenarios with RoadSense™’s HD video
        capabilities:
      </p>
      <ul>
        <li>
          <strong>Accident Footage Recording:</strong> Capture clear, actionable
          visuals during critical events.
        </li>
        <li>
          <strong>On-Demand Video Retrieval:</strong> Quickly access and share
          footage for accurate analysis.
        </li>
        <li>
          <strong>Liability Protection:</strong> Defend against false claims,
          streamline insurance processes, and cut legal costs.
        </li>
      </ul>
      <p>
        RoadSense™ simplifies incident management while safeguarding your
        fleet’s reputation and bottom line.
      </p>

      <h4>3. Continuous Driver Coaching and Support</h4>
      <p>
        RoadSense™ builds a culture of safety with real-time driver support:
      </p>
      <ul>
        <li>
          <strong>Automated Alerts:</strong> Guides drivers on distractions,
          fatigue, and unsafe behaviors.
        </li>
        <li>
          <strong>In-Vehicle Communication:</strong> Enables instant two-way
          interaction with Shoora’s 24/7 Control Room for immediate assistance.
        </li>
        <li>
          <strong>Actionable Training:</strong> Drivers receive on-the-spot
          coaching to cultivate safe driving habits.
        </li>
      </ul>
      <p>
        This constant engagement enhances driver performance, reduces risks, and
        ensures long-term fleet efficiency.
      </p>

      <h2>Why RoadSense™ is Your Best Choice</h2>
      <ul>
        <li><strong>AI-Powered Monitoring:</strong> Detects risks and prevents accidents proactively.</li>
        <li><strong>Crystal-Clear Footage:</strong> High-definition video offers indisputable incident evidence.</li>
        <li><strong>Seamless Connectivity:</strong> Real-time communication ensures instant response during emergencies.</li>
        <li><strong>Driver Empowerment:</strong> Reinforces safe driving habits with actionable insights and guidance.</li>
      </ul>

      <blockquote>
        "Protect your fleet, improve driver safety, and prevent accidents with RoadSense™ ADAS Cameras. Shoora delivers the innovation you need to stay ahead."
      </blockquote>         
  `,
};
const RoadSenseADAS = () => {
  useEffect(()=> {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  },[]);
  return (
    <>
      <ArticleHero
        contentType={data?.contentType}
        title={data?.title}
        createdOn={data?.createdOn}
        imgsrc="/images/about/bg8.webp"
      />
      <div className="bg-dark">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#">Insights</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#" className="text-capitalize">
                  {data?.contentType}s
                </a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {data?.title}
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <ArticleContainer data={data} />
      <hr
        className="bordInstantly access video footage for incident reconstruction and complianceer-3"
        style={{ borderColor: "var(--accent-color)" }}
      />
      <div
        className="stories-section section my-5"
        style={{ maxWidth: "100%" }}
      >
        <div className="container">
          <FlipCardSlider data={relatedBlogs} title={"You may also like"} />
        </div>
      </div>
    </>
  );
};

export default RoadSenseADAS;
